exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mark-disabled[data-v-6664364e]{opacity:.4!important}.action-button-component[data-v-6664364e]:hover{opacity:.7!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-6664364e&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/grid/ActionButtonComponent.vue
// module id = 903
// module chunks = 2